import ResetQuantity from "../symbols/resetQuantity";
import { HttpRequestPut } from "../../service";

const getResetQuantityAction = (payload: any) => ({
  type: ResetQuantity.RESET_QUANTITY,
  payload,
});
const getResetQuantitySuccessAction = (payload: any) => ({
  type: ResetQuantity.RESET_QUANTITY_SUCCESS,
  payload,
});
const getResetQuantityFailureAction = () => ({
  type: ResetQuantity.RESET_QUANTITY_FAILURE,
});
const clearResetQuantityAction = () => ({
  type: ResetQuantity.CLEAR_RESET_QUANTITY,
});

export function getResetQuantity(deliveryId: string, orderlineID: string) {
  return (dispatch: any) => {
    dispatch(getResetQuantityAction({}));

    HttpRequestPut(
      `/portal/delivery/${deliveryId}/reset-quantity/${orderlineID}`,
      dispatch,
      getResetQuantitySuccessAction,
      getResetQuantityFailureAction,
      true,
      {}
    );
  };
}

export function clearResetQuantity() {
  return (dispatch: any) => {
    dispatch(clearResetQuantityAction());
  };
}
